import { AbstractControl, FormGroup, ValidationErrors } from "@angular/forms";

export function aggregateValidator(control: AbstractControl): ValidationErrors | null {
    if (control instanceof FormGroup) {
        let errors = {};
        for (const childName of Object.keys(control.controls)) {
            const child = control.controls[childName];
            errors = Object.assign(errors, child.errors);
        }
        if (Object.keys(errors).length > 0) {
            return errors;
        }
    }
    return null;
}
